import useFlag from 'lane-shared/hooks/useFlag';
import { FeatureFlag } from 'constants-flags';

export function useBillingAndPaymentsServicesCRUDEnabled() {
  const isEnabled = useFlag<boolean>(FeatureFlag.EnableBillingProductServicesCRUD, false);

  return Boolean(isEnabled);
}
